import React from 'react';
import { CONTACT_EMAIL } from '@op/constants';
import { TipsMapFunType, TipsMapType } from '..';

export const keyMetricsByMentionsTypeMobileTips: TipsMapType = {
  en: (
    <>
      Categorize the mentions by videos, text posts, social media comments, game
      store reviews, and Discord discussions.
      <br />
      <br />
      Wherein:
      <br />
      Social media comments include comments on both videos and text posts.
      <br />
      Game Store reviews include all reviews from Google Play and the App Store.
      <br />
      Discord discussions include chat group discussion content scraped from the
      Discord website.
    </>
  ),
  zh: (
    <>
      将声量按视频贴、文字贴、社媒评论、商店评论、Discord讨论进行分类。
      <br />
      <br />
      其中：
      <br />
      社媒评论包含视频贴的评论和文字贴的评论。 <br />
      商店评论包含Google Play和App Store的所有评论 <br />
      Discord讨论包含Discord网站爬取的聊天群组讨论内容。
    </>
  ),
};

export const keyMetricsByMentionsTypePCTips: TipsMapType = {
  en: (
    <>
      Categorize the mentions by videos, text posts, social media comments, game
      store reviews, and Discord discussions.
      <br />
      <br />
      Wherein:
      <br />
      Social media comments include comments on both videos and text posts.
      <br />
      Game Store reviews include all reviews from Steam, MetaCritic, Opencritic,
      and Xbox.
      <br />
      Discord discussions include chat group discussion content scraped from the
      Discord website.
    </>
  ),
  zh: (
    <>
      将声量按视频贴、文字贴、社媒评论、商店评论、Discord讨论进行分类。
      <br />
      <br />
      其中：
      <br />
      社媒评论包含视频贴的评论和文字贴的评论。 <br />
      商店评论包含Steam、MetaCritic、Opencritic、Xbox（如有）的所有评论。 <br />
      Discord讨论包含Discord网站爬取的聊天群组讨论内容。
    </>
  ),
};

export const keyMetricsByMentionsTypeConsoleTips: TipsMapType = {
  en: (
    <>
      Categorize the mentions by videos, text posts, social media comments, game
      store reviews, and Discord discussions.
      <br />
      <br />
      Wherein:
      <br />
      Social media comments include comments on both videos and text posts.
      <br />
      Game Store reviews include all reviews from MetaCritic, Opencritic, and
      Xbox.
      <br />
      Discord discussions include chat group discussion content scraped from the
      Discord website.
    </>
  ),
  zh: (
    <>
      将声量按视频贴、文字贴、社媒评论、商店评论、Discord讨论进行分类。
      <br />
      <br />
      其中：
      <br />
      社媒评论包含视频贴的评论和文字贴的评论。 <br />
      商店评论包含MetaCritic、Opencritic、Xbox（如有）的所有评论。 <br />
      Discord讨论包含Discord网站爬取的聊天群组讨论内容。
    </>
  ),
};

/**
 * @deprecated Discord渠道数据已恢复，此提示不再使用
 */
export const keyMetricsDiscordTips: TipsMapType = {
  en: 'The data from the Discord channel is currently temporarily unavailable for retrieval, which may lead to a decrease in mentions. The recovery time will be notified separately.',
  zh: 'Discord渠道数据当前暂时停止获取，可能导致声量下降，恢复时间另行通知。',
};
export const keyMetricsShowEventTips: TipsMapType = {
  en: (
    <>
      After checking the box, operational events that occur on the same day will
      be displayed above the chart corresponding to the date.
      <br />
      Event information is automatically retrieved from the relevant
      announcements of the game's designated platform or from custom
      configurations.
      <br />
      To filter events, please click the edit button located to the right.
      <br />
      <br />
      If the chart does not display any events, it indicates that no events have
      been entered for the selected time period. To add new events, please
      contact {CONTACT_EMAIL}.
    </>
  ),
  zh: (
    <>
      勾选后，当天发生的运营事件将显示在对应日期的图表上方。
      <br />
      事件爬取自游戏指定平台相关公告或自定义配置。
      <br />
      筛选事件，请点击后方的编辑按钮。
      <br />
      <br />
      趋势图如未展示事件，表示当前所选时间范围未录入事件。新增事件请联系
      {CONTACT_EMAIL}。
    </>
  ),
};

export const eventTypeFilterTips: TipsMapType = {
  en: (
    <>
      After checking, the anomaly attribution cards will be displayed in the
      table below. To filter the cards, please click the settings icon on the
      right.
      <br />
      <br />
      This filter operates independently of the "Show Events" toggle.
    </>
  ),
  zh: (
    <>
      勾选后，下方表格会显示异动归因卡片。如需筛选，请点击右侧的设置图标。
      <br />
      <br />
      本筛选器与事件开关互不影响。
    </>
  ),
};

export const keyMetricsPRTips: TipsMapFunType = (date: string) => ({
  en: `No news available for the selected date. Automatically showing latest data from ${date}.`,
  zh: `所选日期暂无新闻，已自动切换至最近有数据的日期${date}。`,
});

export const keyMetricsShowCompetitorTips: TipsMapFunType = (
  onClick?: () => void,
) => ({
  en: (
    <>
      Go to the <a onClick={onClick}> Compare page</a> to customize your
      competitors.
    </>
  ),
  zh: (
    <>
      前往
      <a onClick={onClick}>竞品对比页</a>
      ，即可自定义竞品。
    </>
  ),
});
